import { IServiceRequest } from 'src/services/api/ServiceRequestDashboard/apiContracts';
import Avatar from 'src/components/Avatar';
import React, { useMemo } from 'react';

interface IAttachmentViewerProps {
  data: IServiceRequest;
  onShowImages: (data: IServiceRequest) => void;
}

const AttachmentViewer = ({ data, onShowImages }: IAttachmentViewerProps) => {
  const parsedAttachment = useMemo(() => {
    if (data && data.attachment) {
      try {
        return JSON.parse(data.attachment);
      } catch (e) {
        console.error('Error parsing attachment:', e);
        return null;
      }
    }
    return null;
  }, [data]);

  const validateAttachment: boolean = useMemo(() => {
    if (parsedAttachment && Array.isArray(parsedAttachment)) {
      return parsedAttachment.length > 0;
    }

    if (data && data.attachment) {
      const attachment: string[] = data.attachment.split('/');
      return attachment.length > 0;
    }

    if (data && data.attachment && data.attachment.length > 0) {
      return data.attachment.length > 0;
    }

    return false;
  }, [data, parsedAttachment]);

  const getAttachmentBadge = useMemo(() => {
    if (parsedAttachment && Array.isArray(parsedAttachment)) {
      return parsedAttachment.length > 1 ? 'count' : '';
    }
    return '';
  }, [parsedAttachment]);

  const getAttachmentUrl = useMemo(() => {
    if (parsedAttachment && Array.isArray(parsedAttachment)) {
      return parsedAttachment[0] || '';
    }
    return '';
  }, [parsedAttachment]);

  if (!validateAttachment) {
    return null;
  }

  return (
    <div
      onClick={() => onShowImages(data)}
      style={{ textAlign: 'center', cursor: 'pointer' }}
    >
      <Avatar
        badge={getAttachmentBadge}
        url={getAttachmentUrl}
        size={undefined}
      />
    </div>
  );
};

export default AttachmentViewer;
